import { makeObservable, observable, runInAction } from 'mobx';
import { BaseStore } from '../baseStore';
import { RootStore } from '../rootStore';
import { StatementHeadlinesService } from '/src/api/services';
import { StatementHeadlines } from '/src/lib/models';
import { TGetStatementHeadlinesRequest } from '/src/lib/types';

export interface StatementHeadlinesStoreProps {
  /**
   * Array of Statement Headlines
   */
  statementHeadlines?: StatementHeadlines;
}

export class StatementHeadlinesStore extends BaseStore implements StatementHeadlinesStoreProps {
  statementHeadlines?: StatementHeadlines;

  constructor(rootStore: RootStore) {
    super(rootStore);

    makeObservable(this, {
      statementHeadlines: observable,
    });
  }

  /**** Statement Headlines CRUD ****/

  /**
   * Fetches and caches Statement Headlines data.
   *
   * @param filters - Filters to use when fetching Headlines
   * @returns The Statement Headlines
   */
  get = async (filters: TGetStatementHeadlinesRequest) => {
    const statementHeadlines = await StatementHeadlinesService.get(filters);

    runInAction(() => (this.statementHeadlines = statementHeadlines));
  };
}
